import React from 'react';
import { Trans } from 'react-i18next';
import { changeInfoContactUrl } from '../../shared/constants';
import { LinkOpenNewTab } from '../../shared/LinkOpenNewTab';

export const CannotEditInfoDetailsContent: React.VFC = () => {
  return (
    <>
      <Trans i18nKey="cantEditInfo">
        Some details, like your name and job title, may be provided by your IT or human resources department. If you
        want to update those details, contact them or your admin.
        <LinkOpenNewTab href={changeInfoContactUrl}>Learn more</LinkOpenNewTab>
      </Trans>
    </>
  );
};
